/**
 * Advice & Guidance filters: styled selects that submit a GET form.
 */

import { isBlockOnPage } from "../../src/js/modules/block-present.js";

(function () {
  "use strict";

  if (!isBlockOnPage("advice-guidance")) {
    return;
  }

  function initCustomSelect(container) {
    const select = container.querySelector("select");
    const trigger = container.querySelector(".custom-select-trigger");
    const label = container.querySelector(".custom-select-label");
    const dropdown = container.querySelector(".custom-select-dropdown");

    if (!select || !trigger || !dropdown) return;

    function getSelectedLabel() {
      const opt = select.options[select.selectedIndex];
      return opt ? opt.textContent.trim() : "";
    }

    function buildOptions() {
      dropdown.innerHTML = "";
      const selectedIndex = select.selectedIndex;
      Array.from(select.options).forEach((opt, index) => {
        const div = document.createElement("div");
        div.className = "custom-select-option";
        div.setAttribute("role", "option");
        div.setAttribute("data-value", opt.value);
        div.textContent = opt.textContent.trim();
        if (index === selectedIndex) {
          div.setAttribute("aria-selected", "true");
        }
        dropdown.appendChild(div);
      });
    }

    function open() {
      container.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
      dropdown.hidden = false;
    }

    function close() {
      container.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
      dropdown.hidden = true;
    }

    function choose(value) {
      select.value = value;
      label.textContent = getSelectedLabel();
      buildOptions();
      close();
      select.dispatchEvent(new Event("change", { bubbles: true }));
    }

    label.textContent = getSelectedLabel();
    buildOptions();

    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      if (container.classList.contains("is-open")) {
        close();
      } else {
        open();
      }
    });

    dropdown.addEventListener("click", (e) => {
      const option = e.target.closest(".custom-select-option");
      if (option) {
        e.preventDefault();
        choose(option.getAttribute("data-value"));
      }
    });

    document.addEventListener("click", (e) => {
      if (!container.contains(e.target)) {
        close();
      }
    });
  }

  function initAdviceGuidance() {
    document.querySelectorAll(".advice-guidance").forEach((block) => {
      block.querySelectorAll("[data-custom-select]").forEach(initCustomSelect);

      const form = block.querySelector("form.filters");
      if (!form) {
        return;
      }

      form.addEventListener("change", (event) => {
        if (!event.target.matches("select")) {
          return;
        }

        form.querySelectorAll("select").forEach((select) => {
          select.disabled = select.value === "";
        });
        form.submit();
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAdviceGuidance);
  } else {
    initAdviceGuidance();
  }
})();
